import { useEffect } from 'react'
import { ContentTitle, FundraiserTitle, MarketCare, MarketChildCare, MarketChildItem, MarketChildList, MarketChildNumber, MarketChildTitle, PersonalFundraisersTable, SocialMediaIcon, SocialMediaItem, SocialMediaLabel, SocialMediaList, SocialMediaSection, TableButton } from './myPersonalFundraisersStyle'
import { Button, Image } from 'react-bootstrap'
import CommonTable from '../commonTable'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment'
import TwitterIcon from '../../../assests/images/xicon.svg';
import MailIcon from '../../../assests/images/mail.svg';
import SocialMediaIconImage from '../../../assests/images/facebook.svg';
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { MESSAGE } from '../../../utils/message'
import { fundRaiserDetailHandler } from '../../../redux/slices/myAccount/fundRaiserDetail-slice'
import { unpublishFundraiserHandler } from '../../../redux/slices/myAccount/manageFundraiser-slice'
import { TableColumnsProps } from '../../../utils/types'
import { openInNewTab } from '../../../utils/functions'
import { truncateSync } from 'fs'
const reactUrl = import.meta.env.VITE_WEBSITE_URL;

const PersonalFundraiserDetail = () => {
    const { pathname } = useLocation()
    const { user_id, org_id } = useParams()
    const fundraiserInfo = useSelector((state: any) => state?.fundRaiserDetail?.data?.results)


    const dispatch: any = useDispatch()
    const navigate = useNavigate()

    const handleUnpublishFund = () => {
        try {
            if (user_id && org_id) {
                dispatch(unpublishFundraiserHandler(user_id, org_id))
            }
            navigate(`/users/profile/${user_id}/fundraisers/list`)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (user_id && org_id) {
            dispatch(fundRaiserDetailHandler(user_id, org_id))
        }
        window.scrollTo(0, 0);
    }, [])

    const getShareUrl = (platform: any) => {
        const url = `${reactUrl}/users/profile/1/fundraisers/list`;

        switch (platform) {
            case 'facebook':
                return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
            case 'twitter':
                return `https://twitter.com/intent/tweet?url=${url}`;
            case 'pinterest':
                return `https://pinterest.com/pin/create/button/?url=${url}`;
            case 'linkedin':
                return `https://www.linkedin.com/shareArticle?mini=true&url=${url}`;
            case 'mail':
                return `mailto:nonprofit@gmail.com`;
            default:
                return '#';
        }
    };

    const columns: TableColumnsProps[] = [
        {
            id: 'date',
            header: 'Date',
            render: (text: string) => {
                return <>{moment(text).format("MMM D, YYYY")}</>
            }
        },
        {
            id: 'donor_name',
            header: "Donor Name"
        },
        {
            id: 'amount',
            header: "Donation Amount"
        },
        {
            id: 'email',
            header: "Send Thank You",
            render: (text: string) => {
                return <ContentTitle
                //   onClick={() => navigate('/dashboard/stats/1')}
                >{text}</ContentTitle>;
            }
        }
    ]
    return (
        <MarketCare>
            <FundraiserTitle> {fundraiserInfo?.title}</FundraiserTitle>
            <MarketChildCare>
                <MarketChildList>
                    <MarketChildItem>
                        <MarketChildTitle>{MESSAGE.myGoal}</MarketChildTitle>
                        <MarketChildNumber>$ {fundraiserInfo?.goal}</MarketChildNumber>
                    </MarketChildItem>
                    <MarketChildItem>
                        <MarketChildTitle>{MESSAGE.WeRaised}</MarketChildTitle>
                        <MarketChildNumber>$ {fundraiserInfo?.raised}</MarketChildNumber>
                    </MarketChildItem>
                    <MarketChildItem>
                        <MarketChildTitle>{MESSAGE.weStillNeed}</MarketChildTitle>
                        <MarketChildNumber>$ {fundraiserInfo?.remain}</MarketChildNumber>
                    </MarketChildItem>
                    <MarketChildItem>
                        <MarketChildTitle>{MESSAGE.endDate}:</MarketChildTitle>
                        <MarketChildNumber>{moment(fundraiserInfo?.end_date).format("MMM D, YYYY")}</MarketChildNumber>
                    </MarketChildItem>
                    <MarketChildItem>
                        <MarketChildTitle>{MESSAGE.daysLeft}:</MarketChildTitle>
                        <MarketChildNumber>{fundraiserInfo?.days_left}</MarketChildNumber>
                    </MarketChildItem>
                </MarketChildList>
            </MarketChildCare>

            <SocialMediaSection>
                <SocialMediaList>
                    <SocialMediaItem onClick={() => openInNewTab(getShareUrl('facebook'))}>
                        <SocialMediaIcon><Image src={SocialMediaIconImage} /></SocialMediaIcon>
                        <SocialMediaLabel>{MESSAGE.shareOnFacebook}</SocialMediaLabel>
                    </SocialMediaItem>

                    <SocialMediaItem onClick={() => openInNewTab(getShareUrl('twitter'))}>
                        <SocialMediaIcon><Image src={TwitterIcon} /></SocialMediaIcon>
                        <SocialMediaLabel>{MESSAGE.shareOnTwitter}</SocialMediaLabel>
                    </SocialMediaItem>

                    <SocialMediaItem onClick={() => openInNewTab(getShareUrl('mail'))}>
                        <SocialMediaIcon  ><Image src={MailIcon} /></SocialMediaIcon>
                        <SocialMediaLabel>{MESSAGE.shareOnEmail}</SocialMediaLabel>
                    </SocialMediaItem>

                    <SocialMediaItem>
                        <SocialMediaIcon></SocialMediaIcon>
                        <Button className="btn-outline-success-blue view-fundraiser" onClick={() => navigate(`/personal-fundraisers-details/${fundraiserInfo?.id}`)} disabled={fundraiserInfo?.is_published !== true}>
                            {MESSAGE.viewFundraiser}
                        </Button>
                    </SocialMediaItem>

                </SocialMediaList>
            </SocialMediaSection>

            <PersonalFundraisersTable>
                <CommonTable columns={columns} data={fundraiserInfo?.donors ? fundraiserInfo?.donors : []} handleRowClick={() => { }} />
                <TableButton>
                    <Button className="btn-outline-success-blue"
                        onClick={() => navigate(pathname.replace("details/", `edit/${fundraiserInfo?.review_id}/`), { state: { org_name: fundraiserInfo?.title } })}
                    >{MESSAGE.editFundraiser}</Button>
                    <Button className='btn-border' onClick={() => { handleUnpublishFund() }}>
                        {fundraiserInfo?.is_published === true ? MESSAGE.unpublishFundraiser : MESSAGE.publishFundraiser}
                    </Button>

                </TableButton>
            </PersonalFundraisersTable>
        </MarketCare>
    )
}

export default PersonalFundraiserDetail
